import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './changeLangButtons.module.scss';
import defineLang from '../../utils/defineLanguage';
import { Languages } from '../../i18n';

const ChangeLangButtons: React.FC = () => {
  const history = useHistory();
  const currentLang = defineLang();

  const handlePath = (lang: Languages) => {
    let newRoute = '';

    if (lang === Languages.SV) {
      newRoute = `/${lang}${window.location.pathname.replace('/en', '')}`;
    }
    if (lang === Languages.EN) {
      newRoute = `/${lang}${window.location.pathname.replace('/sv', '')}`;
    }
    if (lang === Languages.FI) {
      newRoute = window.location.pathname.replace('/sv', '').replace('/en', '');
    }

    return history.push(`${newRoute}`);
  };

  return (
    <div className={styles.langs}>
      {(Object.keys(Languages) as Array<keyof typeof Languages>).map(
        (lang, indx) => (
          <span key={lang}>
            <button
              type="button"
              className={
                Languages[lang] === currentLang
                  ? styles.baldLang
                  : styles.language
              }
              disabled={Languages[lang] === currentLang}
              onClick={() => handlePath(Languages[lang])}
            >
              {lang}
            </button>{' '}
            {indx !== Object.keys(Languages).length - 1 ? <span>|</span> : null}{' '}
          </span>
        )
      )}
    </div>
  );
};

export default ChangeLangButtons;
